import directives from './module';
import {SmoothScroll} from '../services/SmoothScroll';

directives.directive('smoothScroll', () => (scope: any,
                                            element: ng.IAugmentedJQuery,
                                            attr: {smoothOffset: string, smoothScroll: string}) => {
        const offset    = parseInt(attr.smoothOffset, 10) || 0;
        const scrollSvc = new SmoothScroll(element[0], offset);
        element.on('click', () => (attr.smoothScroll !== '' && scope[attr.smoothScroll]) && scrollSvc.scroll());
    }
);



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/smoothScrollDirective.ts